<template>
  <div class="listmap p-relative">
    <div class="listmap-area" :class="{'mapbar': polylineItems.length}">
      <l-map
        v-if="showMap"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >
        <l-tile-layer
          :url="url"
          :attribution="attribution"
        />
        <template v-for="(item, key) in items" >
          <l-marker 
            :ref="`marker-${item.id}`"
            v-if="item.lat && item.lon"  
            :lat-lng="setPosition(item)" 
            :key="key"
            >
            <l-popup>
              <div class="marker-popup">
              <h6>{{item.name}}</h6>
                <p v-if="item.dealer" class="my-2">
                      Организация: <b>{{item.dealer.llc_name}}</b><Br/>
                      Владелец: <b>{{item.dealer.full_name}}</b><Br/>
                      Номер телефона: <b>{{item.dealer.phone}}</b><Br/>
                </p>
                <p>
                  Адрес: 
                  <span v-if="item.location"> 
                    <span v-if="item.location.parent">{{item.location.parent.title}}, </span>
                    <span v-if="item.location.title">{{item.location.title}}</span> 
                  </span> <br>
                  {{item.address}}
                </p>
                <p v-if="item.description">
                    Ориентир:  {{item.description}}
                </p>
                <div class="my-2 imgs-marker" v-if="item.media.length">
                  <figure v-for="el in item.media" :key="el.id">
                    <a :href="el.path" target="_blank">
                      <img :src="el.path_small" :alt="el.name">
                    </a>
                  </figure>
                </div>
                <button @click="innerClick(item)" class="btn btn-sm btn-warning mt-3">Открыть</button>
              </div>
            </l-popup>
          </l-marker>
        </template>
        
        <template v-if="polylineItems.length">
            <l-polyline
              v-for="(item, key) in polylineItems"
              :key="item.id"
              :lat-lngs="[[item.shop.lat, item.shop.lon], [
                polylineItems[key+1] ? polylineItems[key+1].shop.lat : item.shop.lat, 
                polylineItems[key+1] ? polylineItems[key+1].shop.lon : item.shop.lon
                ]]"
              :color="polylineItems.length-2 <= key ? '#88502A' : '#822833'"
              :weight="3"
              :smoothFactor="1"
              :className="polylineItems.length-2 <= key ? 'polyline-way last' : 'polyline-way'"
            />
        </template>
        <!-- <template v-if="polyline.latlngs.length">
            <l-polyline
              :lat-lngs="polyline.latlngs"
              :color="polyline.color"
              :weight="1"
              :className="'polyarrow'"
            />
        </template> -->
  
      </l-map>
    </div>
    <template v-if="polylineItems.length">
      <div class="polyline-mapbar">
        <figure v-for="item in polylineItems" :key="item.id">
          <div class="polyline-mapbar__title" @click="open(item.shop.id)">{{ item.shop.title }}</div>
          <div class="polyline-mapbar__date" :title="item.started_at | dateFormat">
            <svg xmlns="http://www.w3.org/2000/svg" id="time" x="0" y="0" version="1.1" viewBox="0 0 29 29" xml:space="preserve"><path d="M14.638 27c-6.893 0-12.5-5.607-12.5-12.5S7.745 2 14.638 2s12.5 5.607 12.5 12.5S21.53 27 14.638 27zm0-23c-5.79 0-10.5 4.71-10.5 10.5S8.848 25 14.638 25s10.5-4.71 10.5-10.5S20.427 4 14.638 4zm-.08 11.42h-6.42a1 1 0 1 1 0-2h5.42V6a1 1 0 1 1 2 0v8.42a1 1 0 0 1-1 1z"/></svg>
            <span>{{ item.started_at | dateLocale}}</span>
          </div>
          <div class="polyline-mapbar__date" :title="item.ended_at | dateFormat">
            <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 512 512" id="flag"><path d="M157.592,37h-45.3A8.408,8.408,0,0,0,104,45.18V459H89.639a8,8,0,0,0,0,16h90.6a8,8,0,0,0,0-16H166V247.008l22.476,12.345a98.77,98.77,0,0,0,106.349-7.742,82.955,82.955,0,0,1,89.23-6.487l34.49,18.778a7.994,7.994,0,0,0,11.815-7.027l0-166.79a8,8,0,0,0-4.176-7.027l-34.5-18.778a99.039,99.039,0,0,0-106.5,7.742,82.649,82.649,0,0,1-89.05,6.486L166,62V45.18A8.513,8.513,0,0,0,157.592,37ZM166,80.219l22.479,12.343a98.867,98.867,0,0,0,106.4-7.74,82.908,82.908,0,0,1,89.2-6.488l30.3,16.5-.017,148.574L391.684,231.07a99.046,99.046,0,0,0-106.507,7.741,82.658,82.658,0,0,1-89.053,6.488L166,228.794ZM120,459V53h30V459Z"/></svg>
            <span>{{ item.ended_at | dateLocale}}</span>
          </div>
        </figure>
      </div>
    </template>
  </div>
  </template>
  <script>
  
  import {mapState} from 'vuex';
  import { latLng, Icon } from "leaflet";
  import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LPolyline } from "vue2-leaflet";
  Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });
  import 'leaflet/dist/leaflet.css';
  export default {
    computed:{
         ...mapState(["lastUpdate"]),
    },
    filters:{
      dateLocale(date){
        if (date && typeof date == 'string') {
          return new Date(date).toLocaleTimeString("ru-RU", {
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })
        }
        return 'Не завершен'
        
      }
    },
     components: {
      LMap,
      LTileLayer,
      LMarker,
      LPopup,
      LTooltip,
      LPolyline
    },
    props:{
        polylineItems: {
          default: [],
        },
        defaultLat:{
            default: 41.311081
        },
        defaultLon:{
            default: 69.240562
        },
        params:{
          default:function(){
            return {};
          }
        },
        cardLink:{
          default:function(){
            return '';
          }
        },
        polyline: {
          default:function(){
            return {
              latlngs: [],
              color: "green"
            };
          }
        },
    },
    created(){
      this.init(1);
    },
    methods: {
      init(page = 1){
        if (page == 1){
          this.items = [];
        }
        let params = {...this.params};
        params['page'] = page;
        this.$http.get('shops', {params:params}).then(response => {
          const data = response.data;
          this.items.push(...data.data);
          if (page<data.meta.last_page) {
              this.init(page+1);
          }
        })
      },
      open(id) {
        this.$refs['marker-'+id][0].mapObject.openPopup();
      },
  
      zoomUpdate(zoom) {
        this.currentZoom = zoom;
      },
      centerUpdate(center) {
        this.currentCenter = center;
      },
      
      innerClick(item) {
        const element = `${this.cardLink}`;
        let query = Object.assign({}, this.$route.query);
        if (query[element] == item.id) {
          return false;
        }
        if (query[element]) {
          delete query[element];
        }
        query[element] = item.id;
        setTimeout(() => {
          this.$router.replace({ query: query });
        }, 20);
      },
      setPosition(item){
        try {
              return  latLng(item.lat, item.lon)
        } catch (error) {
             return  latLng(0,0)
        }
      }
    },
    data() {
      return {
        items:[],
        zoom: 12,
        center:latLng(this.defaultLat ? this.defaultLat  : 41.311081 , this.defaultLon ? this.defaultLon : 69.240562),
        currentCenter: latLng(this.defaultLat ? this.defaultLat  : 41.311081 , this.defaultLon ? this.defaultLon : 69.240562),
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '',
        currentZoom: 11.5,
        showParagraph: false,
        mapOptions: {
          zoomSnap: 0.5
        },
        showMap: true
      };
    },
    watch:{
      params: {
          handler: function (val) {
            setTimeout(() => {
              this.init(1);
            }, 100);
          },
          deep: true,
      },
        lastUpdate(val) {
        if (val) {
          this.init(1);
        }
      },
    }
  };
  </script>
  <style lang="scss">
   .leaflet-control, .leaflet-popup-close-button {
    //opacity:0;
  }
  
  </style>
  